import { render, staticRenderFns } from "./BtFilterWrapperWithBtn.vue?vue&type=template&id=9b6b6160&"
import script from "./BtFilterWrapperWithBtn.vue?vue&type=script&lang=js&"
export * from "./BtFilterWrapperWithBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports